const renderLink = (href: string, termsText: string) => (
  <a href={href} target="_blank" rel="noreferrer">
    {termsText}
  </a>
);

export default function Terms() {
  return (
    <div className="text-small c-black-900 lp-footer-text text-align-center">
      By creating an account, you agree to the {renderLink('/about/terms', 'terms & conditions')},
      the {renderLink('/about/terms/payroll', 'payroll terms')} and our{' '}
      {renderLink('/about/privacy', 'privacy policy')}.
    </div>
  );
}
